module.exports = __webpack_public_path__ + "img/上海.26422baa.png";